import { render, staticRenderFns } from "./LicenseSttingsInfo.vue?vue&type=template&id=2a45bc0c&scoped=true"
import script from "./LicenseSttingsInfo.vue?vue&type=script&lang=js"
export * from "./LicenseSttingsInfo.vue?vue&type=script&lang=js"
import style0 from "./LicenseSttingsInfo.vue?vue&type=style&index=0&id=2a45bc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45bc0c",
  null
  
)

export default component.exports